import { useLocation, useParams, useRouteMatch } from 'react-router'

const titlesPerSection = (i18n) => ({
	users: i18n`Users`,
	settings: i18n`Settings`,
	'settings-v2': i18n`Settings`,
	automation: i18n`Automation`,
	allocation: i18n`Allocation`,
	priority: i18n`Priority`,
	'initial-coordinator-allocation': i18n`Initial coordinator allocation`,
	'coordinator-allocation': i18n`Coordinator allocation`,
	'clinical-manager-allocation': i18n`Clinical manager allocation`,
	'administrative-manager-allocation': i18n`Administrative manager allocation`,
	'final-situation-coordinator-allocation': i18n`Final situation coordinator allocation`,
	triage: i18n`Triage`,
	'medical-evaluation': i18n`Clinical evaluation`,
	'medical-acts-clinical-approval': i18n`Medical acts (Clinical approval)`,
	'appointment-clinical-approval': i18n`Clinical appointment (Clinical approval)`,
	'surgery-clinical-approval': i18n`Surgery (Clinical approval)`,
	'relapse-clinical-approval': i18n`Relapse (Clinical approval)`,
	'transfer-clinical-approval': i18n`Transfer (Clinical approval)`,
	'final-situation-prevision': i18n`Final situation prevision`,
	'non-surgical-admission-requisition': i18n`Non surgical admission`,
	'transfer-opinion': i18n`Transfer opinion`,
	'causal-link-opinion': i18n`Causal link opinion`,
	'clinical-followup-opinion': i18n`Clinical followup opinion`,
	'relapse-opinion': i18n`Relapse opinion`,
	'triage-opinion': i18n`Triage opinion`,
	'triage-opinion-followup': i18n`Triage opinion - Follow up`,
	'management-opinion': i18n`Management opinion`,
	'process-forwarding': i18n`Process forwarding`,
	'events-subscriptions': i18n`Events subscriptions`,
	'system-notifications': i18n`System notifications`,
	'cancel-request-appointment': i18n`CancelRequestAppointment`,
	'cancel-request-requisition': i18n`CancelRequestRequisition`,
})

const useSectionTitle = (i18n, param, defaultValue) => {
	const location = useLocation()
	const params = useParams()
	const match = useRouteMatch(location.pathname)
	const sections = (
		match.path.startsWith('/') ? match.path.slice(1) : match.path
	).split('/')
	const section = param ? params[param] : sections[0]
	const title = titlesPerSection(i18n)[section]
	return title ?? defaultValue ?? ' '
}

export default useSectionTitle
